import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { Routes, Route } from "react-router-dom";
import Home from "./Components/Home";
import Header from "./Components/Header";
import AboutEditorialBoard from "./Components/AboutPageEditorialBoard";
import RegisterForm from "./Components/RegisterForm";
import LoginForm from "./Components/LoginForm";
import ResetForm from "./Components/ResetForm";
import TrackYourArticle from "./Components/TrackYourArticle";
import ContactUs from "./Components/ContactUs";
import Manuscript from "./Components/Manuscript";
import AimAndScope from "./Components/AimAndScrop";
import JournalInsight from "./Components/JournalInsight";
import CurrentIssues from "./Components/CurrentIssue";
import ProcessingFees from "./Components/ProcessingFees";
import ProcessingFeesForm from "./Components/ProcessingFeesForm";
import GuideForAuthor from "./Components/GuideForAuthor";
import FeesAndFunding from "./Components/FeesAndFunding";
import PharmaceuticalScience from "./Components/PharmaceuticalScience";
import MedicalScience from "./Components/MedicalScience";
import BiologicalScience from "./Components/BiologicalScience";
import SearchPage from "./Components/SearchPage";
import Footer from "./Components/Footer";
import DownloadCertificateInput from "./Components/DownloadCertificateInput";
import News from "./Components/News";
import Announcement from "./Components/Announcement";
import MyAccount from "./Components/MyAccount";
import ProtectedRoute from "./Components/ProtectedRoute";
import EssentialforMedicalWriting from "./Components/EssentialforMedicalWriting";
import PaymentSuccess from "./Components/Paymentsuccess";
import PaymentFailed from "./Components/PaymentFailed";
import NewsUpdates from "./Components/NewsUpdates";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import TermsConditions from "./Components/TermsAndCondition";
import RefundPolicy from "./Components/RefundPolicy";
import ScrollToTop from "./Components/ScrollToTop";
import ReviewArticle from "./Components/ReviewArticle";
import ReviewArticlePdfPage from "./Components/ReviewArticlePdfPage";
import ComingSoon from "./Components/ComingSoon";
import Issues from "./Components/Issues";
import Archieve from "./Components/Archieve";
import AboutThePublication from "./Components/AboutThePublication";

function App() {
  useEffect(() => {
    if (localStorage.getItem("projectSession") !== "active") {
      localStorage.clear(); // Clear any stale login
      localStorage.setItem("projectSession", "active"); // Mark session initialized
    }
  }, []);

  return (
    <>
      <Header />
       <ScrollToTop />
      <ToastContainer position="top-center" autoClose={2000} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/about-editorial-board-impact"
          element={<AboutEditorialBoard />}
        />
        <Route path="/register-impact" element={<RegisterForm />} />
        <Route path="/login-impact" element={<LoginForm />} />
        <Route path="/reset-impact" element={<ResetForm />} />
        <Route path="/track-your-article" element={<TrackYourArticle />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route
          path="/submit-your-article-impact"
          element={
            <ProtectedRoute>
              <Manuscript />
            </ProtectedRoute>
          }
        />
        <Route path="/aim-and-scope" element={<AimAndScope />} />
        <Route path="/about-the-publication" element={<AboutThePublication />} />
        <Route path="/journal-insight" element={<JournalInsight />} />
        <Route path="/current-issues" element={<CurrentIssues />} />
        <Route path="/archive" element={<Archieve />} />
        <Route path="/processing-fees" element={<ProcessingFees />} />
        <Route
          path="/processing-fees-form"
          element={
            <ProtectedRoute>
              <ProcessingFeesForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment-success/:id"
          element={
            <ProtectedRoute>
              <PaymentSuccess />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment-failed/:id"
          element={
            <ProtectedRoute>
              <PaymentFailed />
            </ProtectedRoute>
          }
        />
        <Route path="/guide-for-author" element={<GuideForAuthor />} />
        <Route path="/fees-and-funding" element={<FeesAndFunding />} />
        <Route
          path="/pharmaceutical-science"
          element={<PharmaceuticalScience />}
        />
        <Route path="/medical-science" element={<MedicalScience />} />
        <Route path="/biological-science" element={<BiologicalScience />} />
        <Route path="/search-impact" element={<SearchPage />} />
        <Route
          path="/download-certificate"
          element={<DownloadCertificateInput />}
        />
        {/* <Route path="/news" element={<News />} /> */}
        <Route path="/news" element={<NewsUpdates />} />
        <Route path="/announcement" element={<Announcement />} />
        <Route path="/my-account" element={<MyAccount />} />
        <Route path="/privacy-policy-impact" element={<PrivacyPolicy />} />
        <Route
          path="/terms-and-conditions-impact"
          element={<TermsConditions />}
        />
        <Route path="/refund-policy-impact" element={<RefundPolicy />} />
        <Route
          path="/essential-for-medical-writing"
          element={<EssentialforMedicalWriting />}
        />
        <Route
          path="/review-article"
          element={<ReviewArticle />}
        />
        <Route
          path="/optimising-brain-health-lifestyle-interventions-based-on-evidence"
          element={<ReviewArticlePdfPage />}
        />
        <Route
          path="/clinical-study"
          element={<ComingSoon />}
        />
        <Route
          path="/e-journal"
          element={<ComingSoon />}
        />
         <Route
          path="/e-hbr"
          element={<ComingSoon />}
        />
         <Route
          path="/e-magazine"
          element={<ComingSoon />}
        />
         <Route
          path="/e-library"
          element={<ComingSoon />}
        />
        <Route
          path="/international-expert-opinion"
          element={<ComingSoon />}
        />
        <Route
          path="/archieve"
          element={<ComingSoon />}
        />
       
        <Route
          path="/issues/:id/:issue"
          element={<Issues />}
        />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
